export default __webpack_public_path__ + "static/media/award5.684c3992.svg";